<template>
  <div>
    <div class="space-y-4">
      <h4 class="font-medium leading-none">Filter Options</h4>
      <div class="space-y-2">
        <h5 class="text-sm font-medium leading-none">Status</h5>
        <SmartCheckboxGroup
          v-model="form.selectedStatus"
          :options="[
            { label: 'Active', value: 'active' },
            { label: 'Low Battery', value: 'lowbat' },
            { label: 'Disconnected', value: 'disc' }
          ]"
          class="w-full"
        />
        <h5 class="text-sm font-medium leading-none pt-2">Display Size</h5>
        <SmartCheckboxGroup
          v-model="form.selectedSections"
          :options="[
            { label: '2.7 inch', value: '2.7' },
            { label: '4.2 inch', value: '4.2' },
            { label: '7.5 inch', value: '7.5' }
          ]"
          class="w-full"
          placeholder="Select sections"
        />
        <h5 class="text-sm font-medium leading-none pt-2">Template</h5>
        <SmartSelect
          v-model="form.selectedTemplate"
          :options="['Produce Section', 'Dairy Section', 'Bakery Section', 'Electronics Section']"
          placeholder="Select template"
          class="w-full"
        />
      </div>
      <div class="flex justify-end">
        <el-button type="primary" @click="updateValue('apply')">
          Apply Filters
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import SmartSelect from "@/components/SmartControls/SmartSelect.vue";
import SmartCheckboxGroup from "@/components/SmartControls/SmartCheckboxGroup.vue";
export default {
  name: "ETagFilterPanel",
  components: {
    SmartSelect,
    SmartCheckboxGroup,
  },
  emits: ["apply"],
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      form: {
        selectedStatus: [],
        selectedSections: [],
        selectedTemplate: null,
      },
    };
  },
  methods: {
    updateValue(value) {
      this.$emit("apply", value);
    },
  },
};
</script>
